// extracted by mini-css-extract-plugin
export default {"header":"Header_header__cEg2+","heading":"Header_heading__FkwvL","body":"Header_body__fLkZT","info":"Header_info__ooD-L","weatherIcon":"Header_weatherIcon__dHlBV"};